import { CloseIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  Textarea,
} from "@chakra-ui/react";
import ContactModel from "common/components/commonTableModel/ContactModel";
import LeadModel from "common/components/commonTableModel/LeadModel";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { phoneCallSchema } from "common/schema";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { crmConstant } from "services/Crm/constant";
import { putApi, getApi } from "common/services/api";
import { formatTimestamp } from "common/utils/dateFormater";
import WhiteEditIcon from "common/assets/img/whiteEditIcon.png";
import { fetchModuleData } from "common/redux/reducers/dynamicModuleSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getContactList } from "common/redux/reducers/contactLeadSlice";
import { getLeadList } from "common/redux/reducers/contactLeadSlice";
import SearchSelect from "common/components/autoComplete/AutoCompleteSelect";

const EditPhoneCall = (props) => {
  const {
    onClose,
    isOpen,
    setAction,
    phoneCallData,
    id,
    viewMode,
    setViewMode,
    permission,
    provideFormikConfig = () => { }
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [assignmentToData, setAssignmentToData] = useState([]);
  const [contactData, setContactData] = useState([]);

  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const data = phoneCallData || {};
  const [relatedContacts, setRelatedContacts] = useState([]);

  const [minutesInput, setMinutesInput] = useState("");
  const [secondsInput, setSecondsInput] = useState("");

  const formatToInputDateTime = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().slice(0, 16);
  };
  const { formik } = props;

  const initialValues = {
    sender: user?._id,
    recipient: data?.recipient || "",
    callDuration: data?.callDuration || "",
    callNotes: data?.callNotes || "",
    createBy: data?.createBy || "",
    createByLead: data?.createByLead || "",
    // startDate: data?.startDate ,
    startDate: formatToInputDateTime(data?.startDate),
    endDate: data?.endDate ? formatTimestamp(data?.endDate) : "",
    category: data?.createByLead ? crmConstant.lead : crmConstant.contact,
    subject: data?.subject || "",
    callType: data?.callType || "",
    status: data?.status || "",
    createByDeal: "",
    createByAccount: "",
  };


  const formatData = (fetchedData) => ({
    sender: user?._id,
    recipient: fetchedData?.recipient || "",
    callDuration: fetchedData?.callDuration || "",
    callNotes: fetchedData?.callNotes || "",
    createBy: fetchedData?.createBy || "",
    createByLead: fetchedData?.createByLead || "",
    startDate: fetchedData?.startDate
      ? formatToInputDateTime(fetchedData?.startDate)
      : "",
    endDate: fetchedData?.endDate ? formatTimestamp(fetchedData?.endDate) : "",
    category: fetchedData?.createByLead
      ? crmConstant.lead : fetchedData?.createByAccount ? constant.accounts : fetchedData?.createByDeal ? constant.deals :
        crmConstant.contact,
    subject: fetchedData?.subject || "",
    callType: fetchedData?.callType || "",
    status: fetchedData?.status || "",
    createByDeal: fetchedData?.createByDeal || "",
    createByAccount: fetchedData?.createByAccount || "",
  });

  const [initialInfo, setInitialInfo] = useState(null);


  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const updateData = async (values, resetForm) => {
    try {
      setIsLoading(true);

      const filteredValues = Object.fromEntries(
        Object.entries(values).filter(
          ([, value]) =>
            value !== undefined &&
            value !== null &&
            (typeof value !== "string" || value.trim() !== "")
        )
      );

      const response = await putApi(`api/phoneCall/edit/${id}`, filteredValues);

      if (response?.status === 200 || response?.status === 201) {
        toast.success(crmConstant.phoneCallUpdatedSuccess);

        if (props.getData) {
          await props.getData();
        }
        resetForm();
        return;
      }
    } catch (e) {
      toast.error(constant.something_went_wrong);
    } finally {
      setIsLoading(false);
    }
  };

  const dispatch = useDispatch()
  const contacts = useSelector((state) => state.contactLead.contacts);
  const leadData = useSelector((state) => state.contactLead.leads);
  const dynamicModules = useSelector((state) => state.dynamicModule.modules);

    // Initial data fetch - runs once when component mounts
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await dispatch(getContactList({ fetchAllData: true }))
        await dispatch(getLeadList({ fetchAllData: true }))

        const fetchCustomDataFields = async (type) => {
          const res = await getApi(`api/custom-field/?moduleName=${type}`)
          const matchedModule = res?.data?.find((item) => item?.moduleName === type)
          if (matchedModule?._id) {
            await dispatch(
              fetchModuleData({
                moduleId: matchedModule._id,
                fetchAllData: true,
                type: type === "Deals" ? "deal" : "account",
              }),
            )
          }
        }

        await fetchCustomDataFields("Deals")
        await fetchCustomDataFields("Accounts")
      } catch (error) {
        toast.error("Failed to load data")
      }
    }

    fetchInitialData()
  }, [dispatch]) // Only run once on mount

  useEffect(() => {
    console.log("🔹 Contacts from Redux:", contacts)
    if (contacts && contacts.length > 0) {
      setContactData(contacts)
      console.log("🔹 ContactData updated:", contacts)
    }
  }, [contacts])

  
  // useEffect(() => {
  //   if (values.category === "Contact") {
  //     setContactData(contacts);
  //     setAssignmentToData(contacts);
  //   }
  //   else if (values.category === "Lead") {
  //     setAssignmentToData(leadData);
  //   }
  //   else if (values.category === "Deals") {
  //     setAssignmentToData(dynamicModules?.Deals?.data);
  //   } else if (values.category === "Accounts") {
  //     setAssignmentToData(dynamicModules?.Accounts?.data);
  //   }

  // }, [contacts, leadData, dynamicModules])

  // console.log("testing contactData:", contactData);

   // Update assignmentToData based on category and available data
  useEffect(() => {
    if (values.category === "Contact" && contacts?.length > 0) {
      setAssignmentToData(contacts)
      setContactData(contacts)
    } else if (values.category === "Lead" && leadData?.length > 0) {
      setAssignmentToData(leadData)
    } else if (values.category === "Deals" && dynamicModules?.deal?.data?.length > 0) {
      setAssignmentToData(dynamicModules.deal.data)
    } else if (values.category === "Accounts" && dynamicModules?.account?.data?.length > 0) {
      setAssignmentToData(dynamicModules.account.data)
    }

  }, [values.category, contacts, leadData, dynamicModules, dynamicModules?.account?.data, dynamicModules?.deal?.data])


  useEffect(() => {
    const fetchData = async () => {
      values.start = props?.date;
      try {
        if (values.category === "Contact") {
          dispatch(getContactList({ fetchAllData: true }))

        } else if (values.category === "Lead") {
          dispatch(getLeadList({ fetchAllData: true }))
        } else if (["Deals", "Accounts"].includes(values.category)) {
          const res = await getApi(
            `api/custom-field/?moduleName=${values.category}`
          );
          const matchedModule = res?.data?.find(
            (item) => item?.moduleName === values.category
          );

          if (!matchedModule?._id) {
            toast.error(`No module found for ${values.category}`);
            return;
          }

          await dispatch(fetchModuleData({ moduleId: matchedModule?._id, fetchAllData: true, type: values.category }));
        }

      } catch (e) {
        console.error(e);
        toast.error("Something went wrong");
      }
    };

    fetchData();
  }, [props?.date, values.category]);


  const fetchRecipientData = async () => {
    if (values.createBy) {
      let response = await getApi("api/contact/view/", values.createBy);
      if (response?.status === 200) {
        setFieldValue("recipient", response?.data?.contact?.phoneNumber);
        values.recipient = response?.data?.contact?.phoneNumber;
      }
    } else if (values.createByLead) {
      let response = await getApi("api/lead/view/", values.createByLead);
      if (response?.status === 200) {
        setFieldValue("recipient", response?.data?.lead?.leadPhoneNumber);
        values.recipient = response?.data?.lead?.leadPhoneNumber;
      }
    } else {
      setFieldValue("recipient", "");
    }
  };

  useEffect(() => {
    fetchRecipientData();
  }, [values.createBy, values.createByLead]);

  function onChangHeandler(e) {
    if (e.target.value.startsWith(" ")) {
      return;
    }
    handleChange(e);
  }

  function onCloseHandler() {
    onClose();
    formik.resetForm();
  }
  useEffect(() => {
    if (values.createByName) {
      const matchedUser = assignmentToData.find(
        (user) => `${user.firstName} ${user.lastName}` === values.createByName
      );
      if (matchedUser) {
        setFieldValue("createBy", matchedUser._id);
      }
    }
  }, [values.createByName, assignmentToData, setFieldValue]);

  useEffect(() => {
    if (data) {
      const formattedData = formatData(data);
      formik.setValues(formattedData);
      setInitialInfo(formattedData);
    }
  }, [data]);
  useEffect(() => {
    const initialAttendes = values.createBy || "";
    const initialContact = contactData.find(
      (contact) => contact._id === initialAttendes
    );

    if (initialContact) {
      setFieldValue("recipient", initialContact.phoneNumber);
    }
  }, [contactData, setFieldValue, values.createBy]);
  const hasChanges = useMemo(() => {
    if (!initialInfo) return false;
    return JSON.stringify(initialInfo) !== JSON.stringify(formik.values);
  }, [initialInfo, formik.values]);

  useEffect(() => {
    const total = Number(values.callDuration || 0);
    const mins = Math.floor(total / 60);
    const secs = total % 60;
    setMinutesInput(mins > 0 ? String(mins) : "");
    setSecondsInput(secs > 0 ? String(secs) : "");
  }, [values.callDuration]);
  useEffect(() => {
    if (!provideFormikConfig) return;

    const config = {
      initialValues,
      validationSchema: phoneCallSchema,
      onSubmit: (values, { resetForm }) => {
        updateData(values, resetForm);
      },
    };

    provideFormikConfig(config);
  }, [hasChanges]);


  const handleDurationChange = (minsStr, secsStr) => {
    const mins = parseInt(minsStr) || 0;
    const secs = parseInt(secsStr) || 0;
    const totalSeconds = mins * 60 + secs;
    handleChange({ target: { name: "callDuration", value: String(totalSeconds) } });
  };


  return (
    <Box className="manualFormContainer">
      <Box className="manualFormBody">
        {/* Contact Model  */}
        <ContactModel
          isOpen={contactModelOpen}
          data={assignmentToData}
          onClose={setContactModel}
          fieldName="createBy"
          setFieldValue={setFieldValue}
        />
        {/* Lead Model  */}
        <LeadModel
          isOpen={leadModelOpen}
          data={assignmentToData}
          onClose={setLeadModel}
          fieldName="createByLead"
          setFieldValue={setFieldValue}
        />

        <Grid templateColumns="repeat(12, 1fr)" gap={3}>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.callSubject} <Text color={"red.600"}>*</Text>
            </FormLabel>
            <Input
              fontSize="sm"
              onChange={(e) => {
                onChangHeandler(e);
              }}
              disabled={viewMode}
              onBlur={handleBlur}
              value={values.subject}
              name="subject"
              placeholder={crmConstant.enterSubject}
              fontWeight="500"
              borderColor={
                errors?.subject && touched?.subject ? "red.300" : null
              }
            />
            <Text fontSize="sm" mb="10px" color={"red.600"}>
              {" "}
              {errors.subject && touched.subject && errors.subject}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.callType} <Text color={"red.600"}>*</Text>
            </FormLabel>
            <Select
              disabled={viewMode}
              onChange={(e) => {
                setFieldValue("callType", e.target.value);
              }}
              placeholder={crmConstant.select}
              value={values.callType}
            >
              <option value="Inbound">{crmConstant.inBound}</option>
              <option value="Outbound">{crmConstant.outBound}</option>
            </Select>
            <Text mb="10px" fontSize="sm" color={"red.600"}>
              {errors.callType && touched.callType && errors.callType}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.dateAndTime}
              <Text color={"red.600"}>*</Text>
            </FormLabel>
            <Input
              type="datetime-local"
              fontSize="sm"
              disabled={viewMode}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.startDate}
              name="startDate"
              fontWeight="500"
              borderColor={
                errors?.startDate && touched?.startDate ? "red.300" : null
              }
            />
            <Text mb="10px" fontSize="sm" color={"red"}>
              {" "}
              {errors.startDate && touched.startDate && errors.startDate}
            </Text>
          </GridItem>

          {/* <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.callDuration}
              <Text color={"red.600"}>*</Text>
            </FormLabel>
            <InputGroup>
              <Input
                fontSize="sm"
                onChange={(e) => {
                  // Only allow digits (0-9)
                  const value = e.target.value.replace(/[^\d]/g, ""); // Replace non-digit characters
                  handleChange({ target: { name: e.target.name, value } }); // Update the form state
                }}
                disabled={viewMode}
                onBlur={handleBlur}
                value={values.callDuration}
                name="callDuration"
                placeholder={crmConstant.callDuration}
                fontWeight="500"
                borderColor={
                  errors.callDuration && touched.callDuration ? "red.300" : null
                }
              />
              <InputRightElement right={"20px"}>
                <Text fontSize="sm" color="gray.500">
                  {crmConstant.minutes}
                </Text>
              </InputRightElement>
            </InputGroup>
            <Text mb="10px" fontSize="sm" color={"red.600"}>
              {" "}
              {errors.callDuration &&
                touched.callDuration &&
                errors.callDuration}
            </Text>
          </GridItem> */}

          <GridItem colSpan={{ base: 6 }}>
            <FormLabel display="flex" ms="4px" fontSize="sm" fontWeight="500" mb="8px">
              {constant.callDuration}
              <Text color="red.600">*</Text>
            </FormLabel>

            <InputGroup gap={2} display="flex">
              <Box flex="1">
                <Input
                  fontSize="sm"
                  type="number"
                  placeholder="Minutes"
                  value={minutesInput}
                  disabled={viewMode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^\d]/g, "");
                    setMinutesInput(value);
                  }}
                  onBlur={() => handleDurationChange(minutesInput, secondsInput)}
                />
                <Text mt={1} fontSize="xs" color="gray.500">Minutes</Text>
              </Box>

              <Box flex="1">
                <Input
                  fontSize="sm"
                  type="number"
                  placeholder="Seconds"
                  value={secondsInput}
                  disabled={viewMode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^\d]/g, "");
                    setSecondsInput(value);
                  }}
                  onBlur={() => handleDurationChange(minutesInput, secondsInput)}
                />
                <Text mt={1} fontSize="xs" color="gray.500">Seconds</Text>
              </Box>
            </InputGroup>

            {errors.callDuration && touched.callDuration && (
              <Text mb="10px" fontSize="sm" color="red.600">
                {errors.callDuration}
              </Text>
            )}
          </GridItem>

          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.related}
            </FormLabel>
            <Select
              disabled={viewMode}
              onChange={(e) => {
                setFieldValue("category", e.target.value);
                setFieldValue("createBy", "");
                setFieldValue("createByLead", "");
              }}
              value={values.category}
            >
              <option value="Contact">{crmConstant.contact}</option>
              <option value="Lead">{crmConstant.lead}</option>
              <option value={constant.accounts}>{crmConstant.account}</option>
              <option value={constant.deals}>{constant.deal}</option>
            </Select>
            <Text mb="10px" fontSize="sm" color={"red.600"}>
              {errors.category && touched.category && errors.category}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 12, md: 6 }}>
            {values.category === "Contact" ? (
              <>
                <GridItem colSpan={{ base: 12, md: 6 }}>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    mb="8px"
                  >
                    {crmConstant.participant} ({crmConstant.contact})
                  </FormLabel>
                  {/* <Select
                    disabled={viewMode}
                    value={values.createBy}
                    name="createBy"
                    onChange={handleChange}
                    mb={
                      errors.createBy && touched.createBy ? undefined : "10px"
                    }
                    fontWeight="500"
                    placeholder={"Assign To"}
                    borderColor={
                      errors.createBy && touched.createBy ? "red.300" : null
                    }
                  >
                    {assignmentToData?.map((item) => {
                      return (
                        <option value={item._id} key={item._id}>
                          {item?.contactName ?? "-"}
                        </option>
                      );
                    })}
                  </Select> */}

                  <SearchSelect
                    name="createBy"
                    value={values.createBy}
                    options={
                      assignmentToData?.map((item) => ({
                        label: item.contactName || "-",
                        value: item._id,
                      })) || []
                    }
                    placeholder="Assign To"
                    disabled={viewMode}
                    onSelect={({ name, value: selectedValue }) => {
                      setFieldValue(name, selectedValue);
                      handleChange({ target: { name, value: selectedValue } });
                    }}
                    wrapperStyle={{
                      marginBottom:
                        errors.createBy && touched.createBy ? undefined : "10px",
                      border:
                        errors.createBy && touched.createBy ? "1px solid red" : undefined,
                    }}
                  />
                  <Text mb="10px" fontSize="sm" color={"red.600"}>
                    {" "}
                    {errors.createBy && touched.createBy && errors.createBy}
                  </Text>
                </GridItem>
              </>
            ) : values.category === "Lead" ? (
              <>
                <GridItem colSpan={{ base: 12, md: 6 }}>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    mb="8px"
                  >
                    {constant.recipent} ({crmConstant.lead})
                  </FormLabel>
                  {/* <Select
                    disabled={viewMode}
                    value={values.createByLead}
                    name="createByLead"
                    onChange={handleChange}
                    mb={
                      errors.createByLead && touched.createByLead
                        ? undefined
                        : "10px"
                    }
                    fontWeight="500"
                    placeholder={"Assign To"}
                    borderColor={
                      errors.createByLead && touched.createByLead
                        ? "red.300"
                        : null
                    }
                  >
                    {assignmentToData?.map((item) => {
                      return (
                        <option value={item._id} key={item._id}>
                          {values.category === "Contact"
                            ? `${item.firstName} ${item.lastName}`
                            : item.leadName}
                        </option>
                      );
                    })}
                  </Select> */}
                  <SearchSelect
                    name="createByLead"
                    value={values.createByLead}
                    disabled={viewMode}
                    placeholder="Assign To"
                    onSelect={({ name, value: selectedValue }) => {
                      setFieldValue(name, selectedValue)
                      handleChange({ target: { name, value: selectedValue } }) // Preserve Formik's handleChange functionality
                    }}
                    options={
                      assignmentToData?.map((item) => ({
                        value: item._id,
                        label:
                          values.category === "Contact"
                            ? `${item.firstName} ${item.lastName}`
                            : item.leadName || "-",
                      })) || []
                    }
                    wrapperStyle={{
                      marginBottom: errors.createByLead && touched.createByLead ? undefined : "10px",
                      border: errors.createByLead && touched.createByLead ? "1px solid red" : undefined,
                    }}
                  />
                  <Text mb="10px" fontSize="sm" color={"red.600"}>
                    {" "}
                    {errors.createByLead &&
                      touched.createByLead &&
                      errors.createByLead}
                  </Text>
                </GridItem>
              </>
            ) : (
              ""
            )}
            {(values.category === "Accounts" ||
              values.category === "Deals") && (
                <GridItem colSpan={{ base: 12, md: 6 }}>
                  <FormLabel
                    fontSize="sm"
                    fontWeight="500"
                    mb="8px"
                    display="flex"
                    alignItems="center"
                    gap="1"
                  >
                    {crmConstant.recipient} (
                    {values.category === "Accounts"
                      ? constant.accounts
                      : constant.deals}
                    )
                    <Text as="span" color="red">
                      *
                    </Text>
                  </FormLabel>

                  {/* <Select
                    value={
                      values.category === "Accounts"
                        ? values.createByAccount || ""
                        : values.createByDeal || ""
                    }
                    name={
                      values.category === "Accounts"
                        ? "createByAccount"
                        : "createByDeal"
                    }
                    onChange={(e) => {
                      const selectedValue = e.target.value;

                      if (values.category === "Accounts") {
                        setFieldValue("createByAccount", selectedValue);
                      } else {
                        setFieldValue("createByDeal", selectedValue);
                      }

                      const matchedItem = assignmentToData.find(
                        (item) => item._id === selectedValue
                      );
                      const contactIds = matchedItem?.contact?.map(String) || [];
                      const matchedContacts = contactData
                        .filter((c) => contactIds.includes(String(c._id)))
                        .map((contact) => ({
                          value: contact._id,
                          label: contact.contactName || "-",
                          email: contact?.email || "",
                        }));
                      setRelatedContacts(matchedContacts);
                    }}
                    placeholder={crmConstant.assignTo}
                    fontWeight="500"
                    borderColor="gray.200"
                  >
                    {assignmentToData?.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.label || item.dealName || item.accountName || "-"}
                      </option>
                    ))}
                  </Select> */}

                {/* <SearchSelect
                    name={
                      values.category === "Accounts" ? "createByAccount" : "createByDeal"
                    }
                    value={
                      values.category === "Accounts"
                        ? values.createByAccount || ""
                        : values.createByDeal || ""
                    }
                    placeholder={crmConstant.assignTo}
                    onSelect={({ name, value: selectedValue }) => {
                      setFieldValue(name, selectedValue);

                      const matchedItem = assignmentToData.find(
                        (item) => item._id === selectedValue
                      );
                      const contactIds = matchedItem?.contact?.map(String) || [];

                      const matchedContacts = contactData
                        .filter((c) => contactIds.includes(String(c._id)))
                        .map((contact) => ({
                          value: contact._id,
                          label: contact.contactName || "-",
                          email: contact?.email || "",
                        }));

                      setRelatedContacts(matchedContacts);
                    }}
                    options={
                      assignmentToData?.map((item) => ({
                        value: item._id,
                        label: item.label || item.dealName || item.accountName || "-",
                      })) || []
                    }
                    fontWeight="500"
                  /> */}

                <SearchSelect
                  name={values.category === "Accounts" ? "createByAccount" : "createByDeal"}
                  value={values.category === "Accounts" ? values.createByAccount || "" : values.createByDeal || ""}
                  placeholder={crmConstant.assignTo}
                  onSelect={({ name, value: selectedValue }) => {
                    setFieldValue(name, selectedValue)

                    const matchedItem = assignmentToData.find((item) => item._id === selectedValue)

                    const contactIds = matchedItem?.contact?.map(String) || []

                    if (contactData.length === 0) {
                      setRelatedContacts([])
                      return
                    }

                    const matchedContacts = contactData
                      .filter((c) => {
                        const contactIdStr = String(c._id)
                        const isIncluded = contactIds.includes(contactIdStr)
                        return isIncluded
                      })
                      .map((contact) => ({
                        value: contact._id,
                        label: contact.contactName || "-",
                        email: contact?.email || "",
                      }))
                    setRelatedContacts(matchedContacts)
                  }}
                  options={
                    assignmentToData?.map((item) => ({
                      value: item._id,
                      label: item.label || item.dealName || item.accountName || "-",
                    })) || []
                  }
                />

                <Text mb="10px" fontSize="sm" color={"red"}>
                  {(values.category === "Accounts" && errors.createByAccount) ||
                    (values.category === "Deals" && errors.createByDeal)}
                </Text>
                  <Text mb="10px" fontSize="sm" color={"red"}>
                    {(values.category === "Accounts" && errors.createByAccount) ||
                      (values.category === "Deals" && errors.createByDeal)}
                  </Text>
                </GridItem>
              )}
            {relatedContacts.length > 0 && (
              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                  display="flex"
                  alignItems="center"
                  gap="1"
                >
                  {constant.selectContacts} {values.category}
                  <Text as="span" color="red">
                    *
                  </Text>
                </FormLabel>

                {/* <Select
                  name="createBy"
                  value={values.createBy || ""}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    setFieldValue("createBy", selectedId); // Store as string
                    const selectedContact = contactData.find(
                      (contact) => contact._id === selectedId
                    );
                    if (selectedContact) {
                      setFieldValue("recipient", selectedContact.phoneNumber);
                    } else {
                      setFieldValue("recipient", "");
                    }
                  }}
                >
                  <option value="">Select related contacts</option>
                  {relatedContacts.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Select> */}

                <SearchSelect
                  name="createBy"
                  value={values.createBy || ""}
                  placeholder="Select related contacts"
                  onSelect={({ name, value: selectedId }) => {
                    setFieldValue(name, selectedId); // Store as string

                    const selectedContact = contactData.find(
                      (contact) => contact._id === selectedId
                    );

                    if (selectedContact) {
                      setFieldValue("recipient", selectedContact.phoneNumber);
                    } else {
                      setFieldValue("recipient", "");
                    }
                  }}
                  options={
                    relatedContacts.map((item) => ({
                      value: item.value,
                      label: item.label,
                    }))
                  }
                  fontWeight="500"
                />


                <Text mb="10px" fontSize="sm" color="red.600">
                  {errors.createBy && touched.createBy && errors.createBy}
                </Text>
              </GridItem>
            )}
          </GridItem>

          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.contactNo}
              <Text color={"red.600"}>*</Text>
            </FormLabel>
            <Input
              fontSize="sm"
              disabled
              value={values.recipient ? values.recipient : ""}
              name="recipient"
              placeholder="Recipient"
              fontWeight="500"
              borderColor={
                errors.recipient && touched.recipient ? "red.300" : null
              }
            />
          </GridItem>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.status} <Text color={"red.600"}>*</Text>
            </FormLabel>
            <Select
              disabled={viewMode}
              onChange={(e) => {
                setFieldValue("status", e.target.value);
              }}
              placeholder={crmConstant.select}
              value={values.status}
            >
              <option value="Scheduled">{crmConstant.scheduled}</option>
              <option value="Completed">{crmConstant.completed}</option>
            </Select>
            <Text mb="10px" fontSize="sm" color={"red.600"}>
              {errors.status && touched.status && errors.status}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 12 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.description}
            </FormLabel>
            <Textarea
              resize={"none"}
              disabled={viewMode}
              fontSize="sm"
              placeholder={crmConstant.description}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.callNotes}
              name="callNotes"
              fontWeight="500"
              borderColor={
                errors.callNotes && touched.callNotes ? "red.300" : null
              }
            />
            <Text mb="10px" fontSize="sm" color={"red.600"}>
              {" "}
              {errors.callNotes && touched.callNotes && errors.callNotes}
            </Text>
          </GridItem>

          {/* <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.endDate}
            </FormLabel>
            <Input
              type="datetime-local"
              fontSize="sm"
              min={values.startDate}
              disabled={viewMode}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.endDate}
              name="endDate"
              fontWeight="500"
              borderColor={
                errors?.endDate && touched?.endDate ? "red.300" : null
              }
            />
            <Text mb="10px" color={"red"}>
              {" "}
              {errors.endDate && touched.endDate && errors.endDate}
            </Text>
          </GridItem> */}
        </Grid>
      </Box>
      {/* <Flex className="manualFormFooter">
        {viewMode ? (
          (user.role === "superAdmin" || permission?.update) && (
            <Button
              disabled={isLoading}
              onClick={() => setViewMode(false)}
              className="viewEditBtn"
            >
              <Image src={WhiteEditIcon} alt="edit" h={"16px"} w={"16px"} />
              {constant.edit}
            </Button>
          )
        ) : (
          <Flex gap={"16px"}>
            <Button
              sx={{ textTransform: "capitalize" }}
              onClick={() => {
                setViewMode(true);
                formik.setValues(initialInfo);
              }}
              variant="outline"
              className="cancelBtn theme-btn2"
              size="sm"
            >
              {constant.cancel}
            </Button>

            <Button
              sx={{ textTransform: "capitalize" }}
              type="submit"
              disabled={
                isLoading ||
                !formik.isValid ||
                !formik.dirty || !hasChanges
              }
              onClick={handleSubmit}
              className="viewEditBtn"
            >
              {isLoading ? (
                <Spinner
                  size={20}
                  paddingRight={5}
                  border={`3px solid ${globalStyles.colors.loaderBorder}`}
                  borderTop={`1px solid ${globalStyles.colors.transparent}`}
                />
              ) : (
                ""
              )}{" "}
              {constant.upload}
            </Button>
          </Flex>
        )}
      </Flex> */}
    </Box>
  );
};
export default EditPhoneCall;
